import React from "react";
import { Card, Icon, Label } from "semantic-ui-react";
import {capitalizeFirstLetter} from "../../../utils/utils";
export const EUProjectParticipation = ({ profile }) => {
    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h2">EU Project Participation</Card.Header>

                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>EU proposal writer</p>
                    {profile?.eu_proposal_writer ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>
                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>EU project leader</p>
                    {profile?.eu_project_leader ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>
                {
                    profile?.coordinated_projects_and_calls.length > 0 && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <p style={{ fontWeight: 400 }}>Coordinated projects and calls: </p>
                        </div>
                    )
                }
                {
                    profile.coordinated_projects_and_calls.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                        {profile.coordinated_projects_and_calls.map((project) => {
                            return <Label key={project}>{capitalizeFirstLetter(project)}</Label>;
                        })}
                    </div>)
                }
                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>EU project member</p>
                    {profile?.eu_project_member ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>

                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>EU project evaluator</p>
                    {profile?.eu_project_evaluator ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>

                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>Knowledge Transfer</p>
                    {profile?.knowledge_transfer ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ flexDirection: "column", marginRight: "2rem" }}>
                        {profile?.founder_of_a_spin_off && <p style={{ fontWeight: 400}}>- Founder of a spin-off </p>}
                        {profile?.member_of_a_spin_off && <p style={{ fontWeight: 400}}>- Member of a spin-off </p>}
                        {profile?.patents && <p style={{ fontWeight: 400}}>- Patented results </p>}
                        {profile?.member_of_an_industrial_chair
                            && <p style={{ fontWeight: 400}}>- Member of an industrial chair </p>}
                        {(profile?.projects_other && profile?.projects_other_response.length > 0)
                            && <p style={{ fontWeight: 400}}>- Other: {profile?.projects_other_response} </p>}
                    </div>
                </div>

                <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                    <p style={{ fontWeight: 600 }}>Interest in Joint Research Groups</p>
                    {profile?.interest_in_joint_research_groups ? <Icon color="green" name="check" /> : <Icon color="red" name="close" />}
                </div>
            </Card.Content>
        </Card>
    );
};
